import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@carbon/styles/css/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

// ★ 追加：AuthProvider を import
import { AuthProvider } from './auth/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ここでアプリ全体を AuthProvider でラップ */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
